import { createAction, props } from '@ngrx/store';
import { SGPFGDCalculatedDTO } from 'src/app/web-api-client';

export const getMonthlyFuelGas = createAction(
  '[SGP] Get Monthly Fuel Gas',
  props<{ startTime: Date }>()
);
export const getMonthlyFuelGasSuccess = createAction(
  '[SGP] Get Monthly Fuel Gas Success',
  props<{ data: SGPFGDCalculatedDTO[] }>()
);
export const getMonthlyFuelGasFailure = createAction(
  '[SGP] Get Monthly Fuel Gas Failure',
  props<{ message: string }>()
);

export const RefreshMonthlyManualRecords = createAction(
  '[SGP] Refresh Monthly Manual Records',
  props<{ date: Date }>()
);
export const RefreshMonthlyManualRecordsSuccess = createAction(
  '[SGP] Refresh Monthly Manual Records Success',
  props<any>()
);
export const RefreshMonthlyManualRecordsFailure = createAction(
  '[SGP] Refresh Monthly Manual Records Failure',
  props<{ message: string }>()
);